export const tableCellClass = 'border-none px-4';
export const tableCellFullClass = 'border-none px-4 text-nowrap';
export const headlineClass = 'text-nowrap w-full text-grey-500 font-bold inline-flex';
export const claimPageBarClass = 'z-[1200] w-full shrink-0 bg-slate-100 px-12 py-4';
export const claimBarCellMaxWidth = 150;
